<template>
        <div style="clear:both;height:100%;">
            <el-tree :data="treeOptions"
                        default-expand-all
                        node-key="id"
                        ref="tree"
                        highlight-current
                        show-checkbox
                        :props="defaultTreeProps"
                        :default-checked-keys="treecheckedKeys"
                        @check="handleNodeCheck"
                        class="leftTree">
            </el-tree>
            <Datatable :tableName="tableName" :tableFilterColsParamOut="dtFilterCols" :meta="meta" class="rightDataTable"></Datatable>
        </div>
</template>

<script>
    import Datatable from '@/components/Datatable'
    import { getTreeJson } from '@/api/utils'

    export default {
        name: 'DatatableTree',
        components: {
            Datatable
        },
        props: {
            tableName: {
                type: String
            },
            tableNameTree: {
                type: String,
                default:''
            },
            columnTree: {
                type: String,
                default: ''
            },
            meta: {
                type: Object
            }
        },
        data() {
            return {
                defaultTreeProps: {
                    children: 'children',
                    label: 'label'
                },
                treeOptions: [],
                treecheckedKeys:[],
                dtFilterCols:[]
            }
        },
        computed: {
        },
        async created() {
            await this.getTreeData();
        },
        methods: {
            async getTreeData() {
                if (this.tableNameTree != '') {
                    let res = await getTreeJson(this.tableNameTree, {}).catch(() => { });
                    if (res.Code == 1) {
                        this.treeOptions = res.Data.tree;
                        
                        this.getAllIds(this.treeOptions, this.treecheckedKeys);
                        console.log(this.treecheckedKeys);
                    }
                }
            },
            handleNodeCheck(checknode,checkednodes) {
                if (this.tableName != "" && this.columnTree != "") {
                    var filtercol = {
                        filters: [{
                            data: checkednodes.checkedKeys
                        }],
                        columnname: this.columnTree,
                        tablename: this.tableName
                    };
                    this.dtFilterCols = [];
                    this.dtFilterCols.push(filtercol);
                }
            },
            getAllIds(arr,ids) {
                arr.forEach(item => {
                    if (item.id) ids.push(item.id);
                    if (item.children) this.getAllIds(item.children, ids);
                });
            }
        }
    }
</script>

<style scoped>
    .leftTree {
        background: #FAFAFA;
        float: left;
        width: 193px;
        height: calc(100% - 40px);
        border: 1px solid #E8EAEC;
        margin-right:5px;
        padding-top:10px;
    }
    .rightDataTable{
        float:right;
        width:calc(100% - 200px);
    }
</style>